import React, { useEffect, useState } from "react";
import { CheckIcon } from "@heroicons/react/24/outline";
import { useTranslation } from 'react-i18next';

const CustomBannerWithCheckAll = ({ orderNumber, cartId, products, onSelectAllChange, allChecked ,cartIsPacking,cartIsReadyToPaid}) => {
  const [isChecked, setIsChecked] = useState(allChecked);
  const { t } = useTranslation();

  useEffect(() => {
    setIsChecked(allChecked);
  }, [allChecked]);

  const handleChange = () => {
    const newValue = !isChecked;
    setIsChecked(newValue);
    onSelectAllChange(cartId, products, newValue);
  };

  return (
    <div className={`flex items-center justify-between w-full gap-2 p-2 text-black rounded-sm shadow-md lg:p-4 ${cartIsPacking ? "bg-custom-yellow" :"bg-gray-200"} `}>
      <div className="font-bold">
        <span className="text-xs text-gray-800 lg:text-sm">{t("orderNumber")} :</span>
        <span className="text-xs text-gray-800 lg:text-sm"> {orderNumber}</span>
      </div>
      <div className="flex items-center gap-2 font-bold">
        {!cartIsPacking ? 

          <>
          <div className="flex items-center gap-2 cursor-pointer"
            onClick={handleChange}
            >
              <div
                className={`relative w-4 h-4 lg:w-5 lg:h-5 rounded flex items-center justify-center border-2 ${
                  isChecked ? "bg-green-600 border-green-600" : "bg-white border-gray-300"
                }`}                  
              >
                {isChecked && <CheckIcon className="w-4 h-4 text-white" />}
                <input
                  type="checkbox"
                  className="absolute inset-0 opacity-0 cursor-pointer"
                  checked={isChecked}
                  onChange={handleChange} 
                />
              </div>
              <span className="text-xs font-medium text-black lg:text-sm" >
                {t("AllRepackaging")}
              </span>
            </div>
        </>
      :  
        <>
          <div className="flex items-center gap-2"
            >
              {
                cartIsReadyToPaid ? 
                <span className="px-2 md:px-4  py-2 text-xs font-bold text-[#009a3a] lg:text-sm" >
                {t("Repackaged")}
              </span>
                :
                <span className="px-1 md:px-4 py-2 text-xs font-bold text-[#009a3a] lg:text-sm" >
                {t("RepackagProgress")}
              </span>
              }
            </div>
        </>
      }
        
      </div>
    </div>
  );
};


export default CustomBannerWithCheckAll;
